// extracted by mini-css-extract-plugin
module.exports = {"host":"o2-rebrand-theme_host__IDWOJ"};